import { StageNodeSlice } from "slices/stage-nodes/stage-nodes-slice";

export const { updateNode, addNode, clearNodes } = StageNodeSlice.actions;

export default StageNodeSlice.reducer;
